import {  postRequest } from '@/libs/axios';
export const getTrajectoryConfigs = (params) => {
    return postRequest('/ndt/module/logisticsTrajectoryConfig/page', params)
}
export const createTrajectoryConfig = (params) => {
    return postRequest('/ndt/module/logisticsTrajectoryConfig/add', params)
}
export const updateTrajectoryConfig = (params) => {
    return postRequest('/ndt/module/logisticsTrajectoryConfig/update', params)
}
export const deleteTrajectoryConfig = (params) => {
    return postRequest('/ndt/module/logisticsTrajectoryConfig/delete', params)
}
export const getTriggerNodes = (params) => {
    return postRequest('/ndt/module/triggerNode/list', params)
}
export const getOrderStatuses = (params) => {
    return postRequest('/ndt/module/changeOrderStatus/getOption', params)
}
export const updateConfigStatus = (params) => {
    return postRequest('/ndt/module/logisticsTrajectoryConfig/updateConfigStatus', params)
}
export const getAvailableVariables = (params) => {
    return postRequest('/ndt/module/logisticsTrajectoryConfig/getAvailableVariables', params)
}
export const batchAddTrack = (params) => {
    return postRequest('/ndt/order/track/batchAdd', params)
}

export const batchAddTrajectory = (params) => {
    return postRequest('/ndt/order/batchAddTrajectory', params)
}
export const getOrderTrajectory = (params) => {
    return postRequest('/ndt/module/logisticsTrajectoryConfig/list', params)
}
